// services/customers.js
import axiosInstance from './axiosInstance';

const CUSTOMERS_API_URL = '/customers';

const customersService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getById(idempresa, idcustomer) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/getById.php?idempresa=${idempresa}&idcustomer=${idcustomer}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async set(customerData) {
    try {
      const response = await axiosInstance.post(`${CUSTOMERS_API_URL}/set.php`, customerData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unset(idempresa, idcustomer) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/unset.php?idempresa=${idempresa}&idcustomer=${idcustomer}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  // Métodos para household (agregado familiar)
  async getHouseholds(idempresa, idcustomer) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/household/get.php?idempresa=${idempresa}&idcustomer=${idcustomer}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter agregados familiares:', error);
      return [];
    }
  },

  async getHouseholdById(idempresa, idcustomer, idhousehold) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/household/getById.php?idempresa=${idempresa}&idcustomer=${idcustomer}&idhousehold=${idhousehold}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter agregado familiar:', error);
      return [];
    }
  },

  async setHousehold(householdData) {
    try {
      const response = await axiosInstance.post(`${CUSTOMERS_API_URL}/household/set.php`, householdData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar agregado familiar:', error);
      throw error;
    }
  },

  // Métodos para quotas
  async getQuotas(idempresa, idcustomer) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/quotas/get.php?idempresa=${idempresa}&idcustomer=${idcustomer}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter quotas:', error);
      return [];
    }
  },

  async getQuotaById(idempresa, idcustomer, idquota) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/quotas/getById.php?idempresa=${idempresa}&idcustomer=${idcustomer}&idquota=${idquota}`);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter quota:', error);
      return {};
    }
  },

  async setQuota(quotaData) {
    try {
      const response = await axiosInstance.post(`${CUSTOMERS_API_URL}/quotas/set.php`, quotaData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar quota:', error);
      throw error;
    }
  },

  // Métodos para serviços de clientes
  async getServices(idempresa, idcustomer) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/services/get.php?idempresa=${idempresa}&idcustomer=${idcustomer}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter serviços:', error);
      return [];
    }
  },

  async getServiceById(idempresa, idcustomer, idservice) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/services/getById.php?idempresa=${idempresa}&idcustomer=${idcustomer}&idservice=${idservice}`);
      return response.data !== "NOK" ? response.data[0] : [];
    } catch (error) {
      console.error('Erro ao obter serviço:', error);
      return [];
    }
  },

  async setServices(servicesData) {
    try {
      const response = await axiosInstance.post(`${CUSTOMERS_API_URL}/services/set.php`, servicesData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar serviços:', error);
      throw error;
    }
  },

  async unsetService(idempresa, idcustomer, idservice) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/services/unset.php?idempresa=${idempresa}&idcustomer=${idcustomer}&idservice=${idservice}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover serviço:', error);
      throw error;
    }
  },

  async sendEmail(idempresa, idcustomer) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/services/sendEmail.php?idempresa=${idempresa}&idcustomer=${idcustomer}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar email:', error);
      throw error;
    }
  },

  async getPhotosById(idempresa, idcustomer, idservice) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/services/getPhotosById.php?idempresa=${idempresa}&idcustomer=${idcustomer}&idservice=${idservice}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter fotos:', error);
      return [];
    }
  },

  async setPhotos(formData) {
    try {
      const response = await axiosInstance.post(`${CUSTOMERS_API_URL}/services/setPhotos.php`, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar fotos:', error);
      throw error;
    }
  },

  // Métodos para tickets de clientes
  async getTickets(idempresa) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/tickets/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter tickets de clientes:', error);
      throw error;
    }
  },

  async getTicketsById(idempresa, idcustomer) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/tickets/getById.php?idempresa=${idempresa}&idcustomer=${idcustomer}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter tickets de cliente:', error);
      throw error;
    }
  },

  // Métodos para bills (faturas/contas)
  async getBills(idempresa, idcustomer) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/bills/get.php?idempresa=${idempresa}&idcustomer=${idcustomer}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter bills do cliente:', error);
      throw error;
    }
  },

  async unsetBill(idempresa, idcustomer, idbill) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/bills/unset.php?idempresa=${idempresa}&idcustomer=${idcustomer}&idbill=${idbill}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover bill:', error);
      throw error;
    }
  },

  async exportCustomers(idempresa) {
    try {
      const response = await axiosInstance.get(`${CUSTOMERS_API_URL}/export.php?idempresa=${idempresa}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao exportar clientes:', error);
      throw error;
    }
  }
};

export default customersService;
